/* JA cart drawer (perf pass). Zero work at load: only cheap document listeners are registered.
   - "Pairs well with" is fetched when the drawer is open (complementary -> related -> best-sellers), cached per bag.
   - "+ Add" adds without leaving the drawer.
   - Checkout label "Checkout · $X" is server-rendered; while the drawer is open an observer scoped to the open
     drawer (disconnected on close) mirrors ShipInsure's total into it. The button text is never written. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {}, busy = {};

  function grab(url) {
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t;
      var el = d.querySelector('.ja-pairs__inner');
      return el && el.querySelectorAll('[data-ja-pair]').length ? el : null;
    }).catch(function () { return null; });
  }
  function count(el) { return el ? el.querySelectorAll('[data-ja-pair]').length : 0; }
  function load(box) {
    var key = box.dataset.key, id = box.dataset.productId;
    if (key in cache) return show(box, cache[key]);
    if (busy[key]) return; busy[key] = 1;
    var rec = root + 'recommendations/products?section_id=cart-recommendations&limit=10&product_id=' + id + '&intent=';
    var steps = [rec + 'complementary', rec + 'related', root + 'collections/best-sellers?section_id=cart-recommendations'];
    var best = null;
    (function next(i) {
      if (i >= steps.length) return done();
      grab(steps[i]).then(function (el) {
        if (count(el) > count(best)) best = el;
        if (count(best) >= 2) return done();
        next(i + 1);
      });
    })(0);
    function done() {
      cache[key] = best ? best.outerHTML : ''; busy[key] = 0;
      document.querySelectorAll('[data-ja-pairs][data-key="' + key + '"]').forEach(function (b) { show(b, cache[key]); });
    }
  }
  function show(box, html) {
    if (box.dataset.state) return;
    box.dataset.state = '1';
    if (html) { box.innerHTML = html; box.hidden = false; }
  }

  /* ShipInsure owns the button text ("CHECKOUT — $X"); we never write it. The visible label is a server-rendered
     overlay ([data-ja-co-label]); while the drawer is open we copy ShipInsure's total into it and the aria-label. */
  function relabel(b) {
    if (!b) return;
    var lab = b.parentNode && b.parentNode.querySelector('[data-ja-co-label]');
    var t = b.textContent.replace(/\s+/g, ' ').trim();
    var m = t.match(/^checkout\s*(?:[—–\-·:]\s*)?(.*)$/i);
    if (!lab || !m) return;
    var want = 'Checkout' + (m[1] ? ' · ' + m[1] : '');
    if (lab.textContent !== want) lab.textContent = want;
    if (b.getAttribute('aria-label') !== want) b.setAttribute('aria-label', want);
  }
  function updating() {
    document.querySelectorAll('[data-ja-co-label]').forEach(function (l) { l.textContent = 'Updating…'; });
  }
  document.addEventListener('cart:refresh', updating);

  /* Drawer: watch only the drawer host for the 'open' attribute (set on first interaction, not at load). */
  var host, inner, q = 0;
  function tick() {
    q = 0;
    var dr = host.querySelector('drawer-component');
    var open = dr && dr.hasAttribute('open');
    if (!open) { if (inner) { inner.disconnect(); inner = null; } return; }
    var box = dr.querySelector('[data-ja-pairs]:not([data-state])');
    if (box && window.fetch) load(box);
    relabel(dr.querySelector('[data-checkout-button]'));
    if (!inner) {
      inner = new MutationObserver(function () { if (!q) { q = 1; requestAnimationFrame(tick); } });
      inner.observe(dr, { childList: true, subtree: true });
    }
  }
  function arm() {
    if (host !== undefined) return;
    host = document.getElementById('cart-drawer');
    if (!host) return;
    var cb = function () { if (!q) { q = 1; requestAnimationFrame(tick); } };
    new MutationObserver(cb).observe(host, { childList: true }); /* drawer replaced by cart:refresh */
    new MutationObserver(cb).observe(host, { attributes: true, attributeFilter: ['open'], subtree: true }); /* open / close */
    tick();
  }
  ['pointerdown', 'keydown', 'cart:refresh', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, arm, { once: true, passive: true, capture: true });
  });

  /* /cart page (fallback, no drawer): relabel once after load and once more after ShipInsure renders. */
  if (document.querySelector('.f-cart__footer [name=checkout]')) {
    var fix = function () { relabel(document.querySelector('.f-cart__footer [name=checkout]')); };
    window.addEventListener('load', function () { fix(); setTimeout(fix, 1500); });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-ja-pair-form]') || !window.fetch) return;
    e.preventDefault();
    var b = f.querySelector('button');
    if (b) { b.disabled = true; b.textContent = 'Adding…'; }
    var fd = new FormData(f); fd.append('quantity', '1');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        if (b) { b.disabled = false; b.textContent = '+ Add'; }
        var live = document.getElementById('CartDrawer-CartErrors');
        if (live) live.textContent = (err && (err.description || err.message)) || 'Could not add this item. Please try again.';
      });
  });
})();
